import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { filterCMSData, getSubIcon } from '@app-helpers/functions';
import { SyllabusModel } from '@app-models/syllabus';
import { TestlistService } from '@app-services/test/testlist.service';
import { NgxSpinnerService } from 'ngx-spinner';
// import { getSubIcon } from "fun"

@Component({
  selector: 'app-view-syllabus',
  templateUrl: './view-syllabus.component.html',
  styleUrls: ['./view-syllabus.component.css']
})
export class ViewSyllabusComponent implements OnInit {
  examtype = "MOCKTESTS";
  examId = "NEET";
  syllabusDetails: any;
  getSubIcon = getSubIcon;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private testListService: TestlistService, 
    private spinner: NgxSpinnerService
  ) { }
  

  ngOnInit(): void {  
    this.examId = this.data?.examId;
    if(this.examId =='score' ){
      this.getScoreSyallabus();
    }else{
      this.getTestSyllebus();
    }
  }

  getTestSyllebus() {
    this.spinner.show();
    this.testListService.getTestSyllebus(this.examId).subscribe(result => {
      console.log(result);
      this.syllabusDetails = result?.syllabus;
      // this.syllabusDetails = this.syllabusDetails.sort((a, b) => a.subjectname.localeCompare(b.subjectname));
      this.spinner.hide();
      console.log(this.syllabusDetails);
    }, (err) => {
      this.spinner.hide();
    });
  }

  getScoreSyallabus(){
    let cmsDetails: any = filterCMSData()
    let params = {
      examtype:cmsDetails?.[0]?.UAM_Exam_Name?.replaceAll(' ',"")?.toUpperCase(),grade:cmsDetails?.[0]?.CMS_grade_id
    }
    this.testListService.getScoreSyllabus(params).subscribe((res:any) =>{
      console.log(res)
      this.syllabusDetails = res?.syllabus
      ;

    })
  }
}
